import { render } from "./FlowView.vue?vue&type=template&id=cc9bf464&scoped=true"
import script from "./FlowView.vue?vue&type=script&lang=js"
export * from "./FlowView.vue?vue&type=script&lang=js"

import "./FlowView.vue?vue&type=style&index=0&id=cc9bf464&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc9bf464"]])

export default __exports__